import { LogLevel } from '@azure/msal-browser';

// import {ResponseMode} from "@azure/msal-common/dist/utils/Constants";
// import {AccountInfo} from "@azure/msal-common/dist/account/AccountInfo";
// import {StringDict} from "@azure/msal-common/dist/utils/MsalTypes";

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */

// Config object to be passed to Msal on creation
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MS_ID,
    authority: `https://login.microsoftonline.com/common`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: '/',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            /* eslint-disable-next-line */
            console.error(message);
            return;
          case LogLevel.Info:
            /* eslint-disable-next-line */
            console.info(message);
            return;
          case LogLevel.Verbose:
            /* eslint-disable-next-line */
            console.debug(message);
            return;
          case LogLevel.Warning:
            /* eslint-disable-next-line */
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

// Scopes you add here will be prompted for consent during login
/* eslint-disable-next-line */
export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'offline_access'],
  prompt: 'select_account',

  // redirectUri: string;
  // account?: AccountInfo;
  // domainHint?: string;
  // extraQueryParameters?: StringDict;
  // extraScopesToConsent?: Array<string>;
  // loginHint?: string;
  // nonce?: string;
  // prompt?: string;
  // sid?: string;
  // state?: string;;
};
